export default function RankingIcon({ className = "", onClick = null }) {
  return (
    <>
      <svg
        className={className}
        onClick={onClick}
        id="Capa_1"
        data-name="Capa 1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 700 700"
      >
        <path
          d="M567.5,412.63c6.35,0,11.51-5.16,11.51-11.51v-50.47c0-6.35-5.16-11.51-11.51-11.51h-130.03v-163.66h26.07c6.35,0,11.51-5.16,11.51-11.51v-50.47c0-6.35-5.16-11.51-11.51-11.51h-227.49c-6.34,0-11.51,5.16-11.51,11.51v50.47c0,6.35,5.16,11.51,11.51,11.51h26.07v68.47h-129.19c-6.35,0-11.51,5.16-11.51,11.51v50.47c0,6.35,5.16,11.51,11.51,11.51h15.63v207.08h-16.05c-6.35,0-11.51,5.16-11.51,11.51v50.47c0,6.35,5.16,11.51,11.51,11.51h434.58c6.35,0,11.51-5.16,11.51-11.51v-50.47c0-6.35-5.16-11.51-11.51-11.51h-16.05v-111.89h16.47ZM262.11,525.64h-51.77v-208.21h51.77v208.21ZM376.09,525.64h-52.18v-1.13h0V175.48h52.19v350.16ZM489.24,525.64h-51.77v-113.02h51.77v113.02Z"          style={{ strokeWidth: "0px" }}
        />
      </svg>
    </>
  );
}
